import CompanyProfileDto from '@/models/Companies/CompanyProfileDto';
import BranchDto from '@/models/Branches/BranchDto';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';

export default class InvoiceSearchViewModel {
    selectedCompany: CompanyProfileDto | null = null;
    selectedStatus: number | null = null;
    selectedType: number | null = null;
    companies: CompanyProfileDto[] = [];
    weekCommencingDate = '';
}
